/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { MessagingChannel } from 'cio/utils/setup-guide/messaging-channels';
import { computed } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import SetupGuideModel from 'cio/models/setup-guide';
import EnvironmentService from 'cio/services/environment';

const NEED_HELP_MESSAGES = {
  email: 'Need help with your DNS settings?',
  push: 'Not sure where to find your authorization key?',
  slack: "Don't have the right Slack permissions?",
  twilio: "Don't have your Twilio credentials nearby?",
  webhook: 'Not the person who will create webhooks?',
  in_app: "Don't have the right permissions?",
};

const NEXT_UP_HELP_MESSAGES = {
  email: 'Set up email messages',
  push: 'Set up push messages for your iOS & Android apps.',
  slack: 'Keep your team informed using Slack actions',
  twilio: 'Set up Twilio messages',
  webhook: 'Connect to other apps and services using webhooks',
  in_app: 'Set up in-app messages',
};

interface SetupGuideChannelFooterArgs {
  setupGuide: SetupGuideModel;
  channel: MessagingChannel;
}

export default class SetupGuideChannelFooter extends Component<SetupGuideChannelFooterArgs> {
  @service environment!: EnvironmentService;
  @service router!: RouterService;

  @computed('args.channel.completedAt', 'environment.current.enabledActions.length')
  get isDoneWithSetup() {
    return this.args.setupGuide.isChannelDoneWithSetup(this.args.channel);
  }

  @computed('args.channel.type')
  get needsHelpMessage() {
    return NEED_HELP_MESSAGES[this.args.channel.type];
  }

  @computed('router.currentRouteName', 'args.channel.type')
  get linkToStep() {
    let url = this.router.urlFor(`setup-guide.channels.${this.args.channel.type}`);
    return `${window.location.origin}${url}`;
  }

  @computed('args.setupGuide.messagingChannels.length', 'environment.current.enabledActions.length')
  get nextChannel() {
    let { messagingChannels } = this.args.setupGuide;
    let index = messagingChannels.indexOf(this.args.channel);
    return messagingChannels[index + 1];
  }

  @computed('nextChannel.type')
  get nextUpMessage() {
    let { nextChannel } = this;

    if (nextChannel == null) {
      return '';
    }

    return NEXT_UP_HELP_MESSAGES[nextChannel.type];
  }
}
